// @flow
/* eslint-disable eqeqeq */
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from '../../utils'

// Utilities
const getColumnStyles = (cols, col) => {
  let columnStyles = {}
  if (col === 'auto') {
    columnStyles = { flexBasis: 'auto' }
  } else if (col == 0) {
    columnStyles = {
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: 'auto',
      maxWidth: 'none',
      width: 'auto',
    }
  } else if (col >= 0) {
    const percents = (col / cols) * 100
    columnStyles = {
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: `${percents}%`,
      maxWidth: `${percents}%`,
    }
  }
  return columnStyles
}

const getVerticalAlignStyles = (valign) => {
  switch (valign) {
    case 'center':
      return { alignSelf: 'center' }
    case 'top':
      return { alignSelf: 'flex-start' }
    case 'bottom':
      return { alignSelf: 'flex-end' }
    case 'normal':
    default:
      return {}
  }
}

const getHorizontalGutterStyles = (shouldHaveGutter, length, index, edge) => {
  if ((length <= 1 || !shouldHaveGutter) && !edge) {
    return { padding: '0' }
  }
  if (
    (index > 0 || (edge && index === 0)) &&
    (index < length - 1 || (edge && index === length - 1))
  ) {
    return { paddingLeft: '5px', paddingRight: '5px' }
  }
  if (index === 0) {
    return { paddingRight: '5px' }
  }
  if (index === length - 1) {
    return { paddingLeft: '5px' }
  }
  return {}
}

const getVerticalGutterStyles = (shouldHaveGutter, length, index, edge) => {
  if ((length <= 1 || !shouldHaveGutter) && !edge) {
    return { padding: '0' }
  }
  if (
    (index > 0 || (edge && index === 0)) &&
    (index < length - 1 || (edge && index === length - 1))
  ) {
    return { paddingTop: '5px', paddingBottom: '5px' }
  }
  if (index === 0) {
    return { paddingBottom: '5px' }
  }
  if (index === length - 1) {
    return { paddingTop: '5px' }
  }
  return {}
}

const getBorderStyles = ($palette, $innerBorder, side) => {
  if (!$innerBorder) return {}
  const paramName = `border${side}`
  return {
    ':not(:last-child)': {
      [paramName]: `1px solid ${$palette($innerBorder)}`,
    },
  }
}

// Container for the items group
export const Container = styled<{
  $wrap?: string,
  $color?: string,
  $edgeGutter?: boolean,
  $verticalGutter?: boolean,
  $horizontalGutter?: boolean,
}>(
  'div',
  ({
    $wrap,
    $color,
    $edgeGutter,
    $verticalGutter,
    $horizontalGutter,
    $palette,
  }) => ({
    display: 'flex',
    flexFlow: `row ${$wrap === 'auto' ? 'wrap' : 'nowrap'}`,
    flexGrow: 1,
    backgroundColor: `${$palette($color)}`,
    ...($edgeGutter && $horizontalGutter
      ? { marginLeft: '-5px', marginRight: '-5px' }
      : {}),
    ...($edgeGutter && $verticalGutter
      ? { marginTop: '-5px', marginBottom: '-5px' }
      : {}),
    ...getScreenStyles($wrap, {
      flexFlow: 'column nowrap',
    }),
  })
)

// Item of the group
export const Item = styled<{
  $innerBorder?: string,
  $length?: number,
  $index?: number,
  $cols?: number,
  $col?: number,
  $valign?: string,
  $verticalGutter?: boolean,
  $horizontalGutter?: boolean,
  $flexible?: boolean,
  $wrap?: string,
  $edgeGutter?: boolean,
}>(
  'div',
  ({
    $innerBorder,
    $length = 1,
    $index = 0,
    $cols = 1,
    $col = 0,
    $valign = 'normal',
    $verticalGutter,
    $horizontalGutter,
    $flexible,
    $wrap,
    $palette,
    $edgeGutter,
  }) => ({
    boxSizing: 'border-box',
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%',
    position: 'relative',
    width: $flexible ? 'auto' : '100%',
    minHeight: '1px',
    ...($flexible && $verticalGutter
      ? getVerticalGutterStyles($verticalGutter, $length, $index, $edgeGutter)
      : {}),
    ...getScreenStyles(
      $wrap,
      {
        ...getBorderStyles($palette, $innerBorder, 'Bottom'),
        ...getVerticalGutterStyles(
          $verticalGutter,
          $length,
          $index,
          $edgeGutter
        ),
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'auto',
        width: 'auto',
        maxWidth: 'none',
      },
      {
        ...getBorderStyles($palette, $innerBorder, 'Right'),
        ...getHorizontalGutterStyles(
          $horizontalGutter,
          $length,
          $index,
          $edgeGutter
        ),
        ...getVerticalAlignStyles($valign),
        ...getColumnStyles($cols, $flexible ? 'auto' : $col),
        ...($wrap === 'auto' ? { flexBasis: 0 } : {}),
      }
    ),
  })
)
